module.exports = __webpack_public_path__ + "static/img/chunmiao-plan.8c8ae11d.png";